<template>
  <div class="rule-set">
    <div class="close-btn" @click="$emit('close')">
      <i class="fa-light fa-times"></i>
    </div>
    <h3>{{ $t("demo.start-flow.done-header") }}</h3>

    <ul class="rules-list">
      <li v-html="$t('demo.start-flow.step-3.rule-1')"></li>
      <li v-html="$t('demo.start-flow.step-3.rule-2')"></li>
      <li v-html="$t('demo.start-flow.step-3.rule-3')"></li>
      <li v-html="$t('demo.start-flow.step-3.rule-4')"></li>
    </ul>
    <button class="btn btn-primary btn-small" @click="$emit('close')">{{$t('demo.toolbar.close-rules')}}</button>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.rule-set {
  padding: 16px;
  .rules-list {
    padding: 0 0 0 16px;
    list-style-type: circle;
    li {
      margin-bottom: 8px;
    }
  }

  .close-btn {
    cursor: pointer;
    position: absolute;
    right: 8px;
    top: 8px;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    color: var(--charcoal-50);
    &:hover {
      color: var(--charcoal);
    }
  }
}
</style>
